/**
 * Created by johnmc on 2019-01-21
 *
 * Details of leads
 */

export class LeadDetails {
  uid: number; //uid
  uids: string;
  email: string; //email
  email_hash: string; //email_hash
  duplicate: boolean;
  phone: string; //phone
  full_name: string; //full_name
  fuel_type: string; //fuel_type
  approved: boolean; //approved
  mail_sent: string;
  eircode: string;  //eircode
  city: string; //city
  region: string;
  mprn: string;  //mprn
  ber: string;
  gprn: string;
  created: Date; //created
  fresh_state: string;
  image: string;
  image_flag: boolean;
  installation_batch: number; //installation_batch
  installer_company_name: string; //installer_company_name
  geopal_status: string; //geopal_status
  last_updated_date_time: Date; //last_updated_date_time
  address: string; //address
  comment: string; //comment
  removed: boolean;
  job_id: number; //job_id
  serial_number: number; //serial_number
  handed_to_installer: Date;//handed_to_installer
  source: string; //source
  heating_system_id: number;//heating_system_id
  heating_system_name: string; //heating_system_name
  lead_status_id: number; //lead_status_id
  lead_status_name: string; //lead_status_name
  installerid: string; //installerid
  installer_name: string;
  have_wifi: boolean;
  previous_grant: boolean;
  use_time_clock: boolean;
  built_before_2007: boolean;
  dead_lead: boolean; //dead_lead
  export_to_company: string;
  multiple_thermostats: boolean;
  master_sheet_index: number; //master_sheet_index
  last_geopal_update: Date;
}
